import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const AircraftRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--settings--aircraft']}>
    <Route path='*' element={<Index />} />
  </SubRouter>
))
